// 缓存键名常量
export const CACHE_KEYS = {
  LOCATION: 'user_location',
  WEATHER: 'weather_info',
  USER_INFO: 'user_info',
  TOKEN: 'access_token'
};

// 缓存过期时间（毫秒）
export const CACHE_EXPIRY = {
  LOCATION: 24 * 60 * 60 * 1000, // 24小时
  WEATHER: 30 * 60 * 1000,       // 30分钟
  USER_INFO: 7 * 24 * 60 * 60 * 1000, // 7天
  TOKEN: 30 * 24 * 60 * 60 * 1000     // 30天
};

/**
 * 设置缓存
 * @param {string} key - 缓存键名
 * @param {any} value - 缓存值
 * @param {number} expiry - 过期时间（毫秒）
 */
export const setCache = (key, value, expiry) => {
  try {
    const item = {
      value,
      timestamp: Date.now(),
      expiry
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.error('缓存设置失败:', error);
  }
};

/**
 * 获取缓存
 * @param {string} key - 缓存键名
 * @returns {any} 缓存值，如果过期或不存在则返回null
 */
export const getCache = (key) => {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = Date.now();

    // 检查是否过期
    if (item.expiry && now - item.timestamp > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (error) {
    console.error('获取缓存失败:', error);
    return null;
  }
};

/**
 * 删除缓存
 * @param {string} key - 缓存键名
 */
export const removeCache = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('删除缓存失败:', error);
  }
};

/**
 * 清除所有缓存
 */
export const clearCache = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('清除缓存失败:', error);
  }
}; 